import { useBrand } from '@hbo/ui-servicing-react-components';
import ProtectedRoute from 'components/ProtectedRoute/ProtectedRoute';
import AuthenticationWrapper from 'containers/Providers/AuthenticationWrapper';
import { LoggedOut, PageNotFound, Error } from 'pages';
import CaseTracking from 'pages/CaseTracking';
import ConfirmMobileNumber from 'pages/ConfirmMobileNumber';
import FourQuestionVerification from 'pages/FourQuestionVerification';
import Locked from 'pages/Locked';
import OneTimePasscode from 'pages/OneTimePasscode';
import ServerError from 'pages/ServerError';
import ServiceDown from 'pages/ServiceDown';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { RoutePath } from 'types/global';

const router = createBrowserRouter(
  [
    {
      path: RoutePath.FourQuestionVerification,
      element: <AuthenticationWrapper />,
      children: [
        {
          path: RoutePath.FourQuestionVerification,
          element: <FourQuestionVerification />
        },
        {
          path: RoutePath.ConfirmMobileNumber,
          element: <ConfirmMobileNumber />
        },
        {
          path: RoutePath.OneTimePasscode,
          element: <OneTimePasscode />
        },
        {
          path: RoutePath.LoggedOut,
          element: <LoggedOut />
        },
        {
          path: RoutePath.CaseTracking,
          element: <ProtectedRoute element={<CaseTracking />} />
        },
        {
          path: RoutePath.Error,
          element: <Error />
        },
        {
          path: RoutePath.ServerError,
          element: <ServerError />
        },
        {
          path: RoutePath.Locked,
          element: <Locked />
        },
        {
          path: RoutePath.OneTimePasscodeServiceDown,
          element: <ServiceDown />
        }
      ]
    },
    {
      path: '*',
      element: <PageNotFound />
    }
  ],
  {
    basename: process.env.PUBLIC_URL
  }
);

function Routes() {
  const { t } = useTranslation();
  const { brand } = useBrand();

  return (
    <>
      <Helmet titleTemplate={`%s - ${t(`brand.${brand}`)}`} />
      <RouterProvider router={router} />
    </>
  );
}

export default Routes;
